/* User Routes */
const HOME = "home";
const PROPERTIES = "properties";
const PROPERTY_DETAIL = "property-detail";
const EXPERIENCE = "experience";
const MANAGE_PROPERTIES = "manage-properties";
const ALLIANCES = "alliances";

/* Admin Routes */
const ADMIN = "admin";
const ADMIN_HOME = "admin-home";
const ADMIN_LOGIN = "admin-login";
const ADMIN_PROPERTIES = "admin-properties";

export default {
  HOME,
  PROPERTIES,
  PROPERTY_DETAIL,
  EXPERIENCE,
  ADMIN,
  ADMIN_LOGIN,
  ADMIN_PROPERTIES,
  MANAGE_PROPERTIES,
  ALLIANCES
};
